import React, { useEffect, useState } from "react";

const Team = () => {
  useEffect(() => {
    window.scrollTo(0, 0); // Scrolls to the top of the page when component mounts
  }, []);

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Fetch data
  const fetchData = async () => {
    try {
      const response = await fetch("https://mirai-server.vercel.app/all-team");
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      const result = await response.json();
      setData(result);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <div>
      <div className="lg:py-20 sm:py-5 min-h-screen border-t border-blue-200">
        <div className="w-full  max-w-screen-2xl mx-auto p-4 ">
          <h1 className="lg:text-5xl sm:text-2xl font-semibold font-jost customBlue">Team</h1>
          <div className="grid lg:grid-cols-3 sm:grid-cols-2 lg:mt-10 sm:mt-5 lg:gap-5 sm:gap-3">
            {data.map((team) => (
              <div className="mt-2 flex lg:flex-row sm:flex-col gap-5 w-full rounded-xl border border-gray-300 shadow-md ">
                 <img className="lg:w-56 lg:h-56 sm:w-full sm:h-36 object-cover lg:rounded-l-xl sm:rounded-t-xl" src={team.singleImage} alt=""></img>
                 <div className="flex flex-col justify-center items-start p-3">
                   <h1 className="lg:text-2xl sm:text-lg font-jost font-semibold customBlue">{team.title}</h1>
                   <h1 className="lg:text-xl  sm:text-lg font-jost  customBlue">{team.designation}</h1>
                 </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Team;
